<dhs-form [formtype]="''" [config]="config" [fieldGroup]="questionForm" [decorator]="self" [data]="data">
</dhs-form>